import React from 'react';
import { Mail, Phone } from 'lucide-react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-grid">
                    <div className="footer-column">
                        <h3 className="footer-heading">About</h3>
                        <a href="#" className="footer-link">About Us</a>
                    </div>

                    <div className="footer-column">
                        <h3 className="footer-heading">Policy</h3>
                        <div className="footer-links">
                            <a href="#" className="footer-link">Privacy Policy</a>
                            <a href="#" className="footer-link">Terms and Conditions</a>
                            <a href="#" className="footer-link">Contact Us</a>
                        </div>
                    </div>

                    <div className="footer-column">
                        <h3 className="footer-heading">Get In Touch</h3>
                        <div className="contact-info">
                            <p className="address">
                                Flat H, 19/F, Shield Industrial Centre,<br />
                                No. 84-92 Chai Wan Kok Street,<br />
                                Tsuen Wan, N.T., Hong Kong
                            </p>
                            <div className="contact-item">
                                <Mail size={18} />
                                <a href="mailto:Info@hkrnd.com" className="footer-link">
                                    Email: Info@hkrnd.com
                                </a>
                            </div>
                            <div className="contact-item">
                                <Phone size={18} />
                                <a href="tel:+85221442628" className="footer-link">
                                    Phone: +852 2144 2628
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;